import React from 'react';
import Button from '../atoms/Button';

const ReportPresetButton = props => {
    return <Button type="secondary" style={{ marginRight: '10px' }} {...props} />;
};

export default ReportPresetButton;
